(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.MfMarkerClusterGroup = (function(superClass) {
    extend(MfMarkerClusterGroup, superClass);

    function MfMarkerClusterGroup() {
      return MfMarkerClusterGroup.__super__.constructor.apply(this, arguments);
    }

    MfMarkerClusterGroup.prototype._defaultIconCreateFunction = function(cluster) {
      var c, childCount;
      childCount = cluster.getChildCount();
      c = ' marker-cluster-';
      if (childCount < 10) {
        c += 'small';
      } else if (childCount < 100) {
        c += 'medium';
      } else {
        c += 'large';
      }
      return new L.DivIcon({
        html: '<div class="hex-outer"> <div class="hex-left"></div> <div class="hex-middle"></div> <div class="hex-right"></div> </div> <div class="hex-inner"> <div class="hex-left"></div> <div class="hex-middle"></div> <div class="hex-right"></div> </div> <div class="count-text">' + childCount + '</div>',
        className: 'marker-cluster' + c,
        iconSize: new L.Point(44, 44)
      });
    };

    return MfMarkerClusterGroup;

  })(L.MarkerClusterGroup);

}).call(this);
